module.exports = __webpack_public_path__ + "static/media/bannerBlackoutCupom20.16a83cad.jpg";